import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6dad10a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-layout-content" }
const _hoisted_2 = {
  class: "left-layout bf",
  style: {"width":"400px"}
}
const _hoisted_3 = { class: "right-layout bf" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { class: "cos-full-layout" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "aside", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "main", {}, undefined, true)
        ])
      ])
    ]),
    _: 3
  }))
}